import React, { useEffect, useState, useRef } from 'react'
import './V3VideoSplash.css'
import videoSrc from '../assets/video/bk_optimized.mp4'
import lastFrameImg from '../assets/img/last_frame.png'

const V3VideoSplash = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true)
  const [showImage, setShowImage] = useState(false)
  const videoRef = useRef(null)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    // Handler pentru când video-ul se termină - adaugă imaginea peste
    const handleEnded = () => {
      // Afișează imaginea peste video cu fade-in
      setShowImage(true)
      // Apelează onComplete după un scurt delay pentru ca imaginea să aibă timp să facă fade-in
      setTimeout(() => {
        setIsVisible(false)
        if (onComplete) {
          onComplete()
        }
      }, 800)
    }

    // Handler pentru erori - ascunde splash-ul dacă video-ul nu se poate încărca
    const handleError = () => {
      console.warn('Video splash failed to load')
      setIsVisible(false)
      if (onComplete) {
        onComplete()
      }
    }

    video.addEventListener('ended', handleEnded)
    video.addEventListener('error', handleError)

    // Încearcă să pornească video-ul automat
    video.play().catch((error) => {
      console.warn('Autoplay was prevented:', error)
      // Dacă autoplay este blocat, afișează imaginea direct
      setShowImage(true)
      setTimeout(() => {
        setIsVisible(false)
        if (onComplete) {
          onComplete()
        }
      }, 1500)
    })

    return () => {
      video.removeEventListener('ended', handleEnded)
      video.removeEventListener('error', handleError)
    }
  }, [onComplete])

  if (!isVisible) {
    return null
  }

  return (
    <div className="v3-video-splash">
      <video
        ref={videoRef}
        className="v3-video-splash-video"
        muted
        playsInline
        preload="auto"
        poster=""
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {showImage && (
        <img 
          src={lastFrameImg} 
          alt="Background" 
          className="v3-video-splash-image"
        />
      )}
    </div>
  )
}

export default V3VideoSplash

